<template>
  <component :is="way" :country="country" v-bind="$attrs" v-on="$listeners" />
</template>
<script>
import PROCESS_NAMES from "@/process/names";
import OpenRegistrationFormDefault from "./default";
import OpenRegistrationFormVideoresume from "./register-videoresume";
import { STORE_PREFIX } from "@/routes_new/outer/interview/landing/prepare/constants";
const OpenRegistrationFormJtiMib = () =>
  import(
    /* webpackChunkName: "bcg-test" */ "@/process/jti-mib-challenge/components/interview/components/register-form/index.vue"
  );
const OpenRegistrationFormJtiMibPixels = () =>
  import(
    /* webpackChunkName: "bcg-test" */ "@/process/jti-mib-pixels/components/interview/components/register-form/index.vue"
  );
const OpenRegistrationFormQmarketing = () =>
  import(
    /* webpackChunkName: "q-marketing" */ "@/process/qmarketing/routes_new/outer/interview/landing/prepare/components/RegisterForm"
  );

export default {
  name: "open-registration-form",

  components: {
    "default-open-registration-form": OpenRegistrationFormDefault,
    "videoresume-open-registration-form": OpenRegistrationFormVideoresume,
    "jit-mib-open-registration-form": OpenRegistrationFormJtiMib,
    "jit-mib-pixels-open-registration-form": OpenRegistrationFormJtiMibPixels,
    "qmarketing-open-registration-form": OpenRegistrationFormQmarketing
    //OpenRegistrationFormBcgTest,
  },

  props: ["country", 'isVideoresume'],

  computed: {
    process() {
      return (
        this.$store.getters[STORE_PREFIX + "interview/process"] ||
        this.$store.getters["landing/process"]
      );
    },

    way() {
      const way = "open-registration-form";

      if (PROCESS_NAMES.JTI_MIB === this.process) {
        return `jit-mib-${way}`;
      } else if (PROCESS_NAMES.JTI_MIB_PIXELS === this.process) {
        return `jit-mib-pixels-${way}`;
      } else if (this.process === PROCESS_NAMES.QMARKETING) {
        return `${this.process}-${way}`;
      }

      if (this.isVideoresume) {
        return `videoresume-${way}`;
      }

      return `default-${way}`;
    }
  }
};
</script>
